// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costSavingTemplateModal__Fx61y {
  width: 372px;
  height: auto;
}

.modalBody___qxp3 {
  padding: 35px 51px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.modalBodyTitle__QONfF {
  margin-bottom: 30px;
  text-align: center;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.multiplicationFactor__kvDIp {
  width: 100%;
  margin-top: 16px;
}

.recalculation__foc_m {
  margin-top: 16px;
}

.modalFooter__aT_oe {
  padding: 35px 51px 35px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.multiplicationFactorInputHeader__AQPPz {
  margin-bottom: 5px;
}

.multiplicationFactorInputLabel__RxM3W {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
.multiplicationFactorInputLabel__RxM3W:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.multiplicationFactorInput__kq_3B input {
  border: unset;
  padding: 0 15px 0 15px;
  border-left: 1px solid var(--inputs-default-stroke);
}
.multiplicationFactorInput__kq_3B input:active {
  border: unset;
  background: var(--inputs-default-surface-default);
  border-left: 1px solid var(--inputs-default-stroke);
}
.multiplicationFactorInput__kq_3B input:focus-visible {
  border: unset;
  background: var(--inputs-default-surface-default);
  border-left: 1px solid var(--inputs-default-stroke);
}

.multiplicationFactorSelect__oYRxc {
  width: 59px;
}
.multiplicationFactorSelect__oYRxc .react-dropdown-select {
  border: unset;
  padding: 0 5px 0 15px;
  min-width: unset;
}
.multiplicationFactorSelect__oYRxc .react-dropdown-select:active, .multiplicationFactorSelect__oYRxc .react-dropdown-select:hover, .multiplicationFactorSelect__oYRxc .react-dropdown-select:focus-visible, .multiplicationFactorSelect__oYRxc .react-dropdown-select:focus-within {
  border: unset;
}
.multiplicationFactorSelect__oYRxc .react-dropdown-select:active svg, .multiplicationFactorSelect__oYRxc .react-dropdown-select:hover svg, .multiplicationFactorSelect__oYRxc .react-dropdown-select:focus-visible svg, .multiplicationFactorSelect__oYRxc .react-dropdown-select:focus-within svg {
  fill: var(--inputs-focus-stroke);
}

.multiplicationFactorInputWrapper__bUz2H {
  display: flex;
  border: 1px solid var(--inputs-default-stroke);
  background: var(--inputs-default-surface-default);
  border-radius: 2px;
}
.multiplicationFactorInputWrapper__bUz2H:has(input:focus) {
  border: 1px solid var(--inputs-focus-stroke);
  background: var(--inputs-default-surface-default);
}

.helperText__loeTT {
  color: var(--inputs-error-text-helper);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  margin-top: 5px;
  min-height: 12px;
}
@media (max-width: 850px) {
  .helperText__loeTT {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.multiplicationFactorInputWrapperFilled__kkZK7 {
  border: 1px solid var(--inputs-filled-stroke);
  background: var(--inputs-filled-filled-surface);
}

.multiplicationFactorInputWrapperError__BOZwL {
  border: 1px solid var(--inputs-error-stroke);
  background: var(--inputs-error-error-surface);
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CostSavingTemplateModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;AAzEF;;AA4EA;EACE,mBAAA;EACA,kBAAA;EAvBA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAjDF;;AAuEA;EACE,WAAA;EACA,gBAAA;AApEF;;AAuEA;EACE,gBAAA;AApEF;;AAuEA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApEF;;AAuEA;EACE,kBAAA;AApEF;;AAuEA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AApEF;AAsEE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AApEJ;;AAyEE;EACE,aAAA;EACA,sBAAA;EACA,mDAAA;AAtEJ;AAwEI;EACE,aAAA;EACA,iDAAA;EACA,mDAAA;AAtEN;AAyEI;EACE,aAAA;EACA,iDAAA;EACA,mDAAA;AAvEN;;AA4EA;EACE,WAAA;AAzEF;AA2EI;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAzEN;AA2EM;EAIE,aAAA;AA5ER;AA8EQ;EACE,gCAAA;AA5EV;;AAmFA;EACE,aAAA;EACA,8CAAA;EACA,iDAAA;EACA,kBAAA;AAhFF;AAkFE;EACE,4CAAA;EACA,iDAAA;AAhFJ;;AAoFA;EACE,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAjFF;AAmFE;EATF;IAUI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAhFF;AACF;;AAmFA;EACE,6CAAA;EACA,+CAAA;AAhFF;;AAmFA;EACE,4CAAA;EACA,6CAAA;AAhFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.costSavingTemplateModal {\n  width: 372px;\n  height: auto;\n}\n\n.modalBody {\n  padding: 35px 51px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.modalBodyTitle {\n  margin-bottom: 30px;\n  text-align: center;\n  @include modalTitle;\n}\n\n.multiplicationFactor {\n  width: 100%;\n  margin-top: 16px;\n}\n\n.recalculation {\n  margin-top: 16px;\n}\n\n.modalFooter {\n  padding: 35px 51px 35px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.multiplicationFactorInputHeader {\n  margin-bottom: 5px;\n}\n\n.multiplicationFactorInputLabel {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);\n    margin-left: 4px;\n  }\n}\n\n.multiplicationFactorInput {\n  input {\n    border: unset;\n    padding: 0 15px 0 15px;\n    border-left: 1px solid var(--inputs-default-stroke);\n\n    &:active {\n      border: unset;\n      background: var(--inputs-default-surface-default);\n      border-left: 1px solid var(--inputs-default-stroke);\n    }\n\n    &:focus-visible {\n      border: unset;\n      background: var(--inputs-default-surface-default);\n      border-left: 1px solid var(--inputs-default-stroke);\n    }\n  }\n}\n\n.multiplicationFactorSelect {\n  width: 59px;\n  :global {\n    .react-dropdown-select {\n      border: unset;\n      padding: 0 5px 0 15px;\n      min-width: unset;\n\n      &:active,\n      &:hover,\n      &:focus-visible,\n      &:focus-within {\n        border: unset;\n\n        svg {\n          fill: var(--inputs-focus-stroke);\n        }\n      }\n    }\n  }\n}\n\n.multiplicationFactorInputWrapper {\n  display: flex;\n  border: 1px solid var(--inputs-default-stroke);\n  background: var(--inputs-default-surface-default);\n  border-radius: 2px;\n\n  &:has(input:focus) {\n    border: 1px solid var(--inputs-focus-stroke);\n    background: var(--inputs-default-surface-default);\n  }\n}\n\n.helperText {\n  color: var(--inputs-error-text-helper);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  margin-top: 5px;\n  min-height: 12px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.multiplicationFactorInputWrapperFilled {\n  border: 1px solid var(--inputs-filled-stroke);\n  background: var(--inputs-filled-filled-surface);\n}\n\n.multiplicationFactorInputWrapperError {\n  border: 1px solid var(--inputs-error-stroke);\n  background: var(--inputs-error-error-surface);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"costSavingTemplateModal": `costSavingTemplateModal__Fx61y`,
	"modalBody": `modalBody___qxp3`,
	"modalBodyTitle": `modalBodyTitle__QONfF`,
	"multiplicationFactor": `multiplicationFactor__kvDIp`,
	"recalculation": `recalculation__foc_m`,
	"modalFooter": `modalFooter__aT_oe`,
	"multiplicationFactorInputHeader": `multiplicationFactorInputHeader__AQPPz`,
	"multiplicationFactorInputLabel": `multiplicationFactorInputLabel__RxM3W`,
	"multiplicationFactorInput": `multiplicationFactorInput__kq_3B`,
	"multiplicationFactorSelect": `multiplicationFactorSelect__oYRxc`,
	"multiplicationFactorInputWrapper": `multiplicationFactorInputWrapper__bUz2H`,
	"helperText": `helperText__loeTT`,
	"multiplicationFactorInputWrapperFilled": `multiplicationFactorInputWrapperFilled__kkZK7`,
	"multiplicationFactorInputWrapperError": `multiplicationFactorInputWrapperError__BOZwL`
};
module.exports = ___CSS_LOADER_EXPORT___;
